/**
 * @generated SignedSource<<505c4556652b8994222cf45ec7d7623a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleShiftsEmployeeNamePanel_employee$data = {
  readonly firstName: string;
  readonly lastName: string | null;
  readonly " $fragmentType": "EmployeeScheduleShiftsEmployeeNamePanel_employee";
};
export type EmployeeScheduleShiftsEmployeeNamePanel_employee$key = {
  readonly " $data"?: EmployeeScheduleShiftsEmployeeNamePanel_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleShiftsEmployeeNamePanel_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeScheduleShiftsEmployeeNamePanel_employee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "82961a13fd051b2f1913098e55ee818b";

export default node;
